module.exports = __webpack_public_path__ + "img/facebook-icon.8882bc23.svg";